module.exports = __webpack_public_path__ + "img/my-type-4.6a528ea0.png";